// Shared map styling constants used across both Stimulus controllers and React components

export const MAP_COLORS = {
  primary: {
    base: "#2563EB",
    hover: "#83a5f4",
    selected: "white",
  },
  sampleSite: {
    base: "#38BDF8",
    primary: "#38BDF8",
    backup: "gray",
    inaccessible: "red",
    field_work_failed: "red",
    recorded: "green",
    research: "purple",
    other: "yellow",
  },
  ui: {
    white: "white",
    lightGray: "LightGray",
    gray: "gray",
    red: "red",
    green: "green",
    yellow: "yellow",
    purple: "purple",
  },
};

export const DEFAULT_PADDING = 60;

// Fat and tiny circle configurations for different zoom levels
export const CIRCLE_CONFIG = {
  "circle-radius": 6,
  "circle-stroke-color": MAP_COLORS.ui.lightGray,
  "circle-stroke-width": 2,
  minzoom: 14,
};

export const TINY_CIRCLE_CONFIG = {
  "circle-radius": 3,
  "circle-stroke-color": MAP_COLORS.ui.lightGray,
  "circle-stroke-width": 1,
  maxzoom: 14,
};

export const MAP_STYLE = "mapbox://styles/mapbox/satellite-streets-v11";
